import React from 'react';
import styled from 'styled-components';
import Profile_share from '../../../assets/profile/profile-share.png';
import { featureImage } from '../../../assets/images';


function WallofElts() {
  const [isProfileShareVisible, setProfileShareVisible] = React.useState(true);

  const handleProfileShareToggle = () => {
    setProfileShareVisible(!isProfileShareVisible);
  };
  const handleShare = (platform) => {
    const url = "https://spoelt.com";
    const message = `We are Spoelt!\n\nWe curate unmatchable deals exclusively for our community members, with a priority on 'Authentic' products and 'Lowest' prices.\n\nJoin us to 'Never pay retail price again, Period.'\n\n${url}`;

    if (platform === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
    } else if (platform === 'instagram') {
      window.open(`https://www.instagram.com/?url=${encodeURIComponent(url)}`, '_blank');
    }
  };
  const isMobile = window.innerWidth <= 991;
  return (
    <div style={{ position: 'relative' }}>
      <EltsDescription>As a mark of appreciation for helping build our awesome community,<br /> <strong>The first 10,000 members' names</strong> will be featured forever on our website! </EltsDescription>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {isProfileShareVisible && !isMobile && (
          <div>
            <ProfileShareImage
              src={Profile_share}
              alt="Profile Share"
              loading="lazy"
              onClick={() => handleShare('whatsapp')}
            />
            <span
              onClick={handleProfileShareToggle}
              style={{
                position: 'absolute',
                top: '80px',
                right: '-110px',
                cursor: 'pointer',
                fontSize: '20px',
                borderRadius: '50%',
                padding: '2px 5px'
              }}
            >
              x
            </span>
          </div>
        )}
        <FeatureImage src={featureImage} alt="Feature" loading="lazy" />
      </div>
      <SubHeading>
        We are currently accepting only [50K users registrations]
      </SubHeading>
      <EltsDescription>Post this, it will be on an invite only basis!</EltsDescription>
    </div>
  );
}
const EltsDescription = styled.p`
  text-align: center;
  margin-top: 30px;
  margin-bottom: 40px;
  font: 400 21px/130% Metrophobic, sans-serif;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
    font-size: 14px;
    text-align:center;
  }
`;

const FeatureImage = styled.img`
  aspect-ratio: 3.23;
  object-fit: contain;
  align-self: center;
  width: 586px;
  margin-top: 21px;
  max-width: 100%;
`;
const ProfileShareImage = styled.img`
  position: absolute;
  top: 100px;
  right: -110px;
  width: 162px; /* Set width to 162px */
  z-index: 2; /* Ensure it appears above other elements */
  cursor: pointer;
  @media (max-width: 991px) {
    display: none; /* Hide for mobile */
  }
`;

const SubHeading = styled.h2`
  margin-top: 26px;
  text-align: center;
  font: 800 20px/108% Inter, sans-serif;
`;
export default WallofElts; 